import { cn } from '@/lib/utils'
import { COLORES_IMPUESTO, type ColorImpuesto } from '@/types/impuestos'

interface CategoriaGastoBadgeProps {
  nombre: string
  color?: string | null
  className?: string
  size?: 'sm' | 'md'
}

/** Resuelve un color guardado (TEXT) al mapa de colores; cae a 'gray' si no matchea. */
const resolverColor = (color?: string | null) =>
  (color && color in COLORES_IMPUESTO ? (color as ColorImpuesto) : 'gray')

export function CategoriaGastoBadge({
  nombre,
  color,
  className,
  size = 'sm',
}: CategoriaGastoBadgeProps) {
  const colores = COLORES_IMPUESTO[resolverColor(color)]

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border font-medium',
        colores.bg,
        colores.text,
        colores.border,
        size === 'sm' ? 'px-1.5 py-0.5 text-xs' : 'px-2 py-1 text-sm',
        className,
      )}
    >
      {nombre}
    </span>
  )
}
